module.exports = __webpack_public_path__ + "static/crowdfunding-mobile-plp-5b637f08e13c8c7475cdd0e88494cfca.png";